const USER_ACCESS_LEVELS = {
  NATIONAL: 'NATIONAL',
  PROVINCE: 'PROVINCE',
  MUNICIPALITY: 'MUNICIPALITY',
};

const USER_ACCESS_LEVELS_ENUM = Object.keys(USER_ACCESS_LEVELS);

const NATIONAL = USER_ACCESS_LEVELS_ENUM[0];
const PROVINCE = USER_ACCESS_LEVELS_ENUM[1];
const MUNICIPALITY = USER_ACCESS_LEVELS_ENUM[2];

export {
  USER_ACCESS_LEVELS,
  USER_ACCESS_LEVELS_ENUM,
  NATIONAL,
  PROVINCE,
  MUNICIPALITY,
};
